<template>
  <el-dialog
    title="投保趋势"
    :visible.sync="dialogVisible"
    width="800px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <div ref="chartContainer" style="width: 100%; height: 400px;"></div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 由于这是一个演示，我们使用模拟数据
// 在实际项目中，您需要引入echarts库
// import * as echarts from 'echarts'

export default {
  name: 'InsuranceTrend',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    companyName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: this.visible
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.$nextTick(() => {
          this.initChart()
        })
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    initChart() {
      // 由于这是一个演示，我们使用简单的文本显示
      // 在实际项目中，您需要使用echarts来绘制图表
      if (this.$refs.chartContainer) {
        this.$refs.chartContainer.innerHTML = `
          <div style="text-align: center; padding-top: 150px;">
            <h3>投保趋势图表</h3>
            <p>公司名称: ${this.companyName}</p>
            <p>这里会显示使用ECharts绘制的投保趋势图表</p>
          </div>
        `
      }
      
      // 在实际项目中，您需要使用以下代码来初始化图表:
      /*
      if (this.$refs.chartContainer) {
        const chart = echarts.init(this.$refs.chartContainer)
        
        // 模拟数据
        const option = {
          title: {
            text: '投保趋势'
          },
          tooltip: {
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月', '6月']
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: [120, 200, 150, 80, 70, 110],
            type: 'line'
          }]
        }
        
        chart.setOption(option)
      }
      */
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>